import { toast } from "sonner";

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            toast("Nouvelle version disponible", {
              description: "Rechargez pour mettre l'application à jour.",
              action: { label: "Recharger", onClick: () => { sw.postMessage("SKIP_WAITING"); window.location.reload(); } },
              duration: 15000,
            });
          }
        });
      });
    } catch (_) { /* SW indisponible (http, navigation privée…) */ }
  });
}

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
